import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem("user");
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const [access, setAccess] = useState(() => {
        const savedAccess = localStorage.getItem("access");
        return savedAccess ? JSON.parse(savedAccess) : [];
    });

    const login = (token, user, access) => {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("access", JSON.stringify(access));

        setUser(user);
        setAccess(access);
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("access");

        setUser(null);
        setAccess([]);
    };

    return (
        <AuthContext.Provider value={{ user, access, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
